import React from "react";
import AddPage from "../component/sections/page/AddPage";
import AllPage from "../component/sections/page/AllPage";
import EditPage from "../component/sections/page/EditPage";
import middleware from "./middlewares/middleware";

const pageRoutes = [
  {
    /* id => web site publisher id */
    path: "/manage/page/add/:id",
    render: () => {
      return middleware(["isUserLogin","checkUserPermissions"], <AddPage />, "AddPage");
    },
    exact: true,
  },
  {
    /* id => page id */
    path: "/manage/page/edit/:id",
    render: () => {
      return middleware(["isUserLogin","checkUserPermissions"], <EditPage />, "EditPage");
    },
    exact: true,
  },
  {
    /* id => web site publisher id */
    path: "/manage/page/all/:id",
    render: () => {
      return middleware(["isUserLogin","checkUserPermissions"], <AllPage />, "AllPage");
    },
    exact: true,
  },
];

export default pageRoutes;
